module.exports = __webpack_public_path__ + "img/nube.aa19388c.svg";